import { usePaginatedQuery } from 'react-query';
import { client } from 'utils/api-client';

export function useTipsAndGuides(params) {
  return usePaginatedQuery(['tips-and-guide', params], (_, pageParams) =>
    client('params/getTipsAndGuide', { params: pageParams }).then((res) => res)
  );
}
